









































import { Vue, Component } from 'vue-property-decorator'
import BigNumber from 'bignumber.js'

const e18 = new BigNumber('1' + '0'.repeat(18))

class Value {
    public value = ''
    get wei() {
        const str = new BigNumber(this.value || 0)
            .times(e18)
            .integerValue(0)
            .toString(10)

        if (/^[0-9]+$/.test(str)) {
            return str
        }
        return null
    }
}

@Component({ name: 'AccountDeposit' })
export default class AccountDeposit extends Vue {
    private address = ''
    private vet = new Value()
    private vtho = new Value()

    private error = null as Error | null

    get price() { return this.$store.state.price }


    private created() {
        this.address = this.$route.params.address.toLowerCase()
    }

    private async send() {
        this.error = null

        try {
            if (!this.vet.wei || !this.vtho.wei) {
                return
            }

            const message: Connex.Vendor.TxMessage = []
            if (this.vet.wei !== '0') {
                message.push({
                    to: this.address,
                    value: this.vet.wei,
                    data: '0x'
                })
            }
            if (this.vtho.wei !== '0') {
                const clause = this.$connex.thor
                    .account(energyContractAddress)
                    .method(energyTransferJsonABI)
                    .asClause(this.address, this.vtho.wei)
                message.push({
                    ...clause,
                    comment: `Transfer ${this.vtho.value} VTHO`
                })
            }
            if (message.length > 0) {
                await this.$connex.vendor.sign('tx')
                    .request(message)

                this.vet.value = ''
                this.vtho.value = ''
                this.error = null;

                (this.$refs.popover as any).show()
            }
        } catch (err) {
            this.error = err
        }
    }
}


const energyContractAddress = '0x0000000000000000000000000000456E65726779'
const energyTransferJsonABI = {
    constant: false,
    inputs: [{
        name: '_to',
        type: 'address'
    }, {
        name: '_amount',
        type: 'uint256'
    }],
    name: 'transfer',
    outputs: [{
        name: 'success',
        type: 'bool'
    }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
}
